import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class AnimationDelay extends BaseOption {
  static userInterfaceComponent = {
    label: "Delay",
    component: inspectorTools.SIMPLE_INPUT,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      inputType: "number",
      min: 0,
      append: "ms",
      defaultEmptyValue: 0,
    },
  };

  static defaultValue = 0;
}
